import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow, Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useResourceInventoriesQuery } from '../../graphql/generated/graphql';
import { InventoryHeadCells } from './const';
import {format} from "date-fns";

const ResourceInventoriesContainer = () => {
  const { id } = useParams();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [rows, setRows] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState(0);

  const { data, loading } = useResourceInventoriesQuery({
    variables: {
      page: page + 1,
      pageSize: rowsPerPage,
      resourceId: Number(id!),
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (data?.resourceInventories.items.length) {
        setRows(data?.resourceInventories.items);
    }
    if (data?.resourceInventories.total) setTotalCount(data.resourceInventories.total);
  }, [data, page]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };

  return (
    <Box width='100%' p={3}>
      <Typography component='div' variant='h6' my={2}>Inventories</Typography>
      <Paper sx={{ width: '100%' }}>
        <TableContainer sx={{ minHeight: 'calc(100vh - 410px)' }}>
          <Table size='small' sx={{ minWidth: 750, minHeight: rows.length === 0 ? 300 : 0 }}>
            <TableHead>
              <TableRow>
                {InventoryHeadCells.map((item, index) => (
                  <TableCell key={index} align='left'>{item.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {
                loading ? (
                  <TableRow>
                    <TableCell colSpan={InventoryHeadCells.length} align="center">
                      <CircularProgress size={24} />
                    </TableCell>
                  </TableRow>
                ) : (
                  rows.map((row, index) => {
                    return (
                      <TableRow key={index} hover tabIndex={-1} sx={{ cursor: 'pointer' }}>
                        <TableCell align='left'>{row.resource.title}</TableCell>
                        <TableCell align='left'>{row.resource.sku}</TableCell>
                        <TableCell align='left'>{row.quantity}</TableCell>
                        <TableCell align='left'>{row.reason ? row.reason : '-'}</TableCell>
                        <TableCell align='left'>{format(new Date(row.createTime), 'MM/dd/yyyy')}</TableCell>
                        <TableCell align='left'>{`${row.user.firstName} ${row.user.lastName}`}</TableCell>
                      </TableRow>
                    );
                  })
                )
              }
              
              
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[15, 25, 50]}
          component='div'
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  )
}

export default ResourceInventoriesContainer;
